export const APP_STORE_URL = 'https://apps.apple.com/us/app/noqueue-charge-ev-stations/id6760142119';
export const APP_STORE_ID = '6760142119';

export const isIOS = () => /iPhone|iPad|iPod/.test(navigator.userAgent);

export const isAndroid = () => /Android/.test(navigator.userAgent);

export const isMobile = () => isIOS() || isAndroid();

export const isDesktop = () => !isMobile();
